import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DatePipe} from '@angular/common';
import {DebtorDistributionService} from '../../../services/debtor-distribution.service';
import {Invoice} from '../../../../dto/invoice';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-debtor-distribution',
  templateUrl: './debtor-distribution.component.html',
  styleUrls: ['./debtor-distribution.component.scss']
})
export class DebtorDistributionComponent implements OnInit {

  debtorsDataSource: MatTableDataSource<Invoice>;

  constructor(
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private debtorDistributionService: DebtorDistributionService
  ) { }

  debtorsColumns = [
    { columnDef: 'date',           header: 'Date',          cell: (row: Invoice) => `${this.datePipe.transform(row.creationDate, 'dd.MM.yyyy HH:mm')}` },
    { columnDef: 'invoice',        header: 'Invoice',       cell: (row: Invoice) => `${row.code}` },
  ];

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.debtorDistributionService.getInvoicesByDistribution(id).subscribe(result => {
      this.debtorsDataSource = new MatTableDataSource(result.data);
    });
  }

  getViewLink = (item: Invoice): string => '/invoices/' + item.id.toString();
}
